import { useState } from 'react';
import TimeSelector from '../../components/lottery/TimeSelector';
import MonthSelector from '../../components/lottery/MonthSelector';
import BilheteInput from '../../components/lottery/BilheteInput';

export default function TestLoteriaComponents() {
  const [timeCoracao, setTimeCoracao] = useState<string>('');
  const [mesSorte, setMesSorte] = useState<string>('');
  const [bilheteFederal, setBilheteFederal] = useState<string>('');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white p-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-3xl font-bold mb-8">Teste de Componentes de Loteria</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* TimeSelector - Timemania */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4">TimeSelector - Timemania</h2>
            <TimeSelector
              onTimeChange={setTimeCoracao}
              selectedTime={timeCoracao}
            />
            <div className="mt-4 p-4 bg-slate-800 rounded-lg">
              <p className="text-sm text-white/60">Time selecionado:</p>
              <p className="text-cyan-400 font-bold">{timeCoracao || 'Nenhum'}</p>
            </div>
          </div>

          {/* MonthSelector - Dia de Sorte */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4">MonthSelector - Dia de Sorte</h2>
            <MonthSelector
              onMonthChange={setMesSorte}
              selectedMonth={mesSorte}
            />
            <div className="mt-4 p-4 bg-slate-800 rounded-lg">
              <p className="text-sm text-white/60">Mês selecionado:</p>
              <p className="text-cyan-400 font-bold">{mesSorte || 'Nenhum'}</p>
            </div>
          </div>

          {/* BilheteInput - Loteria Federal */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
            <h2 className="text-xl font-bold mb-4">BilheteInput - Loteria Federal</h2>
            <BilheteInput
              onBilheteChange={setBilheteFederal}
              bilhete={bilheteFederal}
            />
            <div className="mt-4 p-4 bg-slate-800 rounded-lg">
              <p className="text-sm text-white/60">Bilhete digitado:</p>
              <p className="text-cyan-400 font-bold">{bilheteFederal.padStart(5, '0') || '00000'}</p>
            </div>
          </div>
        </div>

        {/* Payload Test */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
          <h2 className="text-xl font-bold mb-4">Payload de Teste</h2>
          <div className="bg-slate-800 rounded-lg p-4">
            <pre className="text-sm text-white/80 overflow-auto">
{JSON.stringify({
  timemania: {
    time_coracao: timeCoracao
  },
  dia_de_sorte: {
    mes_sorte: mesSorte
  },
  federal: {
    bilhete: bilheteFederal
  }
}, null, 2)}
            </pre>
          </div>
        </div>

        {/* Test Buttons */}
        <div className="flex gap-4">
          <button
            onClick={() => {
              setTimeCoracao('Flamengo');
              setMesSorte('Janeiro');
              setBilheteFederal('12345');
            }}
            className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl hover:shadow-lg transition-all"
          >
            Preencher Valores de Teste
          </button>
          
          <button
            onClick={() => {
              setTimeCoracao('');
              setMesSorte('');
              setBilheteFederal('');
            }}
            className="px-6 py-3 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all"
          >
            Limpar Valores
          </button>
        </div>
      </div>
    </div>
  );
}